// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.no-data-avaliable-container {
  display: flex;
  background-color: var(--base_color2);
  padding: 2px;
  max-width: 600px;
  margin: 10px auto;
  align-items: center;
}
.no-data-avaliable-container.no-video-container {
  max-width: 700px;
}
.no-data-avaliable-container .illustration-no-video {
  width: 300px;
  height: 224px;
  margin-right: 50px;
}
.no-data-avaliable-container .Illustration {
  width: 200px;
  height: 200px;
  margin-right: 50px;
}
.no-data-avaliable-container.coming-soon {
  max-width: 480px;
  margin: 55px auto;
}
.no-data-avaliable-container.coming-soon .Illustration {
  margin-right: 30px;
}
.no-data-avaliable-container h5 {
  font-size: 36px;
  line-height: 45px;
  margin: 0;
  color: var(--gray_dark1);
}
.no-data-avaliable-container p {
  font-size: 20px;
  line-height: 25px;
  color: var(--gray);
  margin: 0;
}
.no-data-avaliable-container.small {
  margin: 4px auto;
}
.no-data-avaliable-container.small .Illustration {
  width: 50px;
  height: 50px;
  margin-right: 15px;
}
.no-data-avaliable-container.small p {
  display: none;
}
.no-data-avaliable-container.small h5 {
  font-size: 13px;
  line-height: 1;
  color: var(--gray);
}`, "",{"version":3,"sources":["webpack://./src/components/NoDataAvailable/index.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,oCAAA;EACA,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AACF;AACE;EACE,gBAAA;AACJ;AAEE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AAAJ;AAGE;EACE,YAAA;EACA,aAAA;EACA,kBAAA;AADJ;AAIE;EACE,gBAAA;EACA,iBAAA;AAFJ;AAII;EACE,kBAAA;AAFN;AAME;EACE,eAAA;EACA,iBAAA;EACA,SAAA;EACA,wBAAA;AAJJ;AAOE;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,SAAA;AALJ;AAQE;EACE,gBAAA;AANJ;AAQI;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AANN;AASI;EACE,aAAA;AAPN;AASI;EACE,eAAA;EACA,cAAA;EACA,kBAAA;AAPN","sourcesContent":[".no-data-avaliable-container {\n  display: flex;\n  background-color: var(--base_color2);\n  padding: 2px;\n  max-width: 600px;\n  margin: 10px auto;\n  align-items: center;\n\n  &.no-video-container {\n    max-width: 700px;\n  }\n\n  .illustration-no-video {\n    width: 300px;\n    height: 224px;\n    margin-right: 50px;\n  }\n\n  .Illustration {\n    width: 200px;\n    height: 200px;\n    margin-right: 50px;\n  }\n\n  &.coming-soon {\n    max-width: 480px;\n    margin: 55px auto;\n\n    .Illustration {\n      margin-right: 30px;\n    }\n  }\n\n  h5 {\n    font-size: 36px;\n    line-height: 45px;\n    margin: 0;\n    color: var(--gray_dark1);\n  }\n\n  p {\n    font-size: 20px;\n    line-height: 25px;\n    color: var(--gray);\n    margin: 0;\n  }\n\n  &.small {\n    margin: 4px auto;\n\n    .Illustration {\n      width: 50px;\n      height: 50px;\n      margin-right: 15px;\n    }\n\n    p {\n      display: none;\n    }\n    h5 {\n      font-size: 13px;\n      line-height: 1;\n      color: var(--gray);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
